import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "flex flex-col text-center mx-4 lg:mx-auto lg:w-1/3 lg:mt-10 min-h-screen flex-1 aos-fix",
  "data-aos": "fade-in"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "m-3 text-4xl pt-6 font-display" }, "romanization", -1)
const _hoisted_4 = {
  key: 1,
  class: "aos-fix",
  "data-aos": "slide-up"
}
const _hoisted_5 = {
  key: 0,
  id: "audio"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-8 mb-3 text-4xl font-display" }, "audio", -1)
const _hoisted_7 = {
  key: 0,
  class: "mb-4 bg-error text-white rounded py-2"
}
const _hoisted_8 = {
  key: 1,
  class: "mb-4 bg-warning text-white rounded py-2"
}
const _hoisted_9 = {
  key: 2,
  class: "mb-4 bg-error text-white rounded py-2"
}
const _hoisted_10 = {
  key: 4,
  controls: "",
  class: "w-full rounded my-4",
  autoplay: ""
}
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("create audio")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mt-8 pb-3 text-4xl font-display" }, "translation", -1)
const _hoisted_14 = {
  key: 1,
  class: "text-sm pb-4"
}
const _hoisted_15 = { class: "flex justify-center items-center space-x-8" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "translate", -1)
const _hoisted_17 = {
  key: 2,
  class: "aos-fix",
  "data-aos": "slide-up"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5 text-4xl font-display" }, "image", -1)
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col justify-center"
}
const _hoisted_20 = {
  key: 1,
  class: "mx-auto"
}
const _hoisted_21 = {
  key: 0,
  class: "text-sm bg-warning mt-3 text-white py-2"
}
const _hoisted_22 = { class: "flex justify-center items-center space-x-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "search images", -1)
const _hoisted_24 = {
  key: 3,
  "data-aos": "fade-in"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "py-8" }, "click on image to select", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "py-8 flex flex-col space-y-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, "not what you were looking for?"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" try "),
    /*#__PURE__*/_createElementVNode("strong", { class: "text-palette5" }, "manual image search!")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" manual search tutorial "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://streamable.com/4f8jdh",
      target: "_blank",
      class: "underline palette1"
    }, "here")
  ])
], -1)
const _hoisted_27 = {
  key: 3,
  "data-aos": "fade-up"
}
const _hoisted_28 = { class: "flex justify-center items-center space-x-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "add card", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "pt-4 pb-4" }, "or", -1)
const _hoisted_31 = { class: "flex justify-center items-center space-x-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "select image again", -1)
const _hoisted_33 = {
  key: 4,
  "data-aos": "fade-up"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "pb-4" }, "or", -1)
const _hoisted_35 = { class: "flex justify-center items-center space-x-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, "add card without image", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "h-screen" }, null, -1)

import dayjs from "dayjs";
import { post } from "../../server";
import MyInput from "../../components/MyInput.vue";
import MyButton from "../../components/MyButton.vue";
import Loading from "../../components/Loading.vue";
import SquareImage from "../../components/SquareImage.vue";
import Attribution from "../../components/Attribution.vue";
import ImageSelectGrid from "../../components/ImageSelectGrid.vue";
import LanguageDropdown from "../../components/LanguageDropdown.vue";
import { ref, onMounted, watch, computed, Ref } from "vue";

import { ImageInfo } from "../../ImageInfo";
import { LanguageInfo } from "../../LanguageInfo";
import { CardData } from "../../CardData";
import { Romanizer } from "../../Romanizer";
import { save, store } from "@/store";
import { gtag } from "@/gtag";
import AddCardFront from "./AddCardFront.vue";
import AddCardLanguageDetection from "./AddCardLanguageDetection.vue";
import { isPremium } from "@/User";
import { AudioData } from "@/AudioData";
import { isTextToSpeechSupported } from "@/language";
import { useRoute } from "vue-router";
import { AudioCreator } from "@/AudioCreator";
import { TextTranslator } from "@/TextTranslator";
import {ImageSearchResponse} from "@/ImageSearchResponse";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const front = ref("");
const english = ref("");
const romanization: Ref<string | null> = ref(null);
const searchImageText = ref("");
const images: Ref<ImageInfo[] | null> = ref(null);
const selectedImage: Ref<ImageInfo | null> = ref(null);
const loadingImages = ref(false);
const frontLanguage: Ref<LanguageInfo> = ref(new LanguageInfo("auto", "auto"));
const backLanguage: Ref<LanguageInfo> = ref(new LanguageInfo("en", "English"));
const translationError = ref("");
//const testAudioUrl = "https://storage.googleapis.com/easy-flashcards-audio/mariusz---pl-81ab205f3675db4dcb65a7cb845e2b0c06d3e249a64e02e2c1799d00fae6e1177be6932c53fc6cd3"
const audioUrl = ref("");
const isLanguageAuto = computed(() => frontLanguage.value.code == "auto");

if (store.state.frontLanguage) frontLanguage.value = store.state.frontLanguage;
if (store.state.backLanguage) backLanguage.value = store.state.backLanguage;

const ttsSupported = computed(() =>
  isTextToSpeechSupported(frontLanguage.value)
);
const creatingAudio = ref(false);
const audioError = ref("");

const romanizer = new Romanizer();
const user = computed(() => store.state.user);
const canUseAudioFeature = computed(() => {
  if (user.value) return isPremium(user.value);
  return false;
});

/** add english spelling of the word (only implemented for some languages) */
async function romanize(): Promise<void> {
  romanization.value = await romanizer.romanize(
    frontLanguage.value,
    front.value
  );
}

const route = useRoute();
const urlParameters = route.query;

const usingBrowserPlugin = urlParameters != undefined;

/** run this when site is opened from plugin */
async function onBrowserPluginStart() {
  let wordFromUrl = urlParameters.word?.toString();
  if (wordFromUrl == undefined) return;
  if (wordFromUrl == "") return;
  console.log("using browser plugin!")
  if(!isPremium(user.value)) return;
  console.log("premium user!")
  //automatically translate and create audio when using browser plugin & is premium user
  front.value = wordFromUrl;
  if (canUseAudioFeature.value) {
    onAddAudio();
  }
  await translateToEnglish();
  searchImage();
}

if (usingBrowserPlugin) onBrowserPluginStart();


async function onAddAudio() {
  if(isLanguageAuto.value) return;
  
  creatingAudio.value = true;
  const createAudio = new AudioCreator();
  createAudio.language = frontLanguage.value;
  createAudio.text = front.value;
  let result = await createAudio.create();
  if (result.error) {
    console.error(result.error);
    if (result.error == "Not Found") result.error = "something went wrong";
    audioError.value = result.error;
  }
  if (result.audioUrl) {
    audioUrl.value = result.audioUrl;
  }
  creatingAudio.value = false;
}


async function translateToEnglish(): Promise<void> {
  console.log("translate");
  let text = front.value;

  let translator = new TextTranslator();
  translator.text = text;
  translator.fromLanguage = frontLanguage.value;
  translator.toLanguage= backLanguage.value;
  translator.sessionId = store.state.sessionId??"";

  const result = await translator.translate();

  english.value = result.translation?.toLowerCase() ?? "";

  if (result.error != null) {
    translationError.value = result.error;
  }
  if (result.error) {
    console.log(result.error);
    translationError.value = "failed to translate the word";
  }
}

async function searchImage(): Promise<void> {
  loadingImages.value = true;
  let text = searchImageText.value;

  let json: ImageSearchResponse = await post("image/search", {
    text: text,
    sessionId: store.state.sessionId,
  });
  loadingImages.value = false;

  images.value = json.images ?? null;
}

function selectImage(image: ImageInfo) {
  selectedImage.value = image;
}

async function addCard() {
  let flashcard = new CardData();
  let audio = new AudioData();
  audio.url = audioUrl.value;
  flashcard.front = front.value;
  flashcard.back = english.value;
  flashcard.image = selectedImage.value;
  flashcard.interval = 0;
  flashcard.repetition = 0;
  flashcard.efactor = 2.5;
  flashcard.dueDate = dayjs(Date.now()).toISOString();
  flashcard.audio = audio;

  if (romanization.value) {
    flashcard.romanization = romanization.value;
  }

  let res: CardData = await post("card", {
    card: flashcard,
    sessionId: store.state.sessionId,
  });

  //check if response is valid
  if (res.front) {
    store.commit("addCard", res);
  }

  gtag.event("added-card");
  if (urlParameters.close) {
    console.log("closing");
    window.close();
  } else {
    //commented out to test stuff
    reset();
  }
}

function reset(): void {
  front.value = "";
  english.value = "";
  searchImageText.value = "";
  images.value = null;
  selectedImage.value = null;
}

const englishWord = computed(() => {
  if (frontLanguage.value.code == "en") return front.value;
  if (backLanguage.value.code == "en") return english.value;

  console.log(`back language: ${backLanguage.value}`);
  return null;
});

watch(english, () => {
  images.value = null;
  selectedImage.value = null;
});

watch(searchImageText, () => {
  images.value = null;
  selectedImage.value = null;
});

watch(backLanguage, () => {
  english.value = "";
  store.state.backLanguage = backLanguage.value;
  saveStore();
});

watch(front, () => {
  english.value = "";
  audioUrl.value = "";
  romanize();
});
/** saves store values to local storage */
function saveStore() {
  save(store.state);
}
watch(frontLanguage, () => {
  store.state.frontLanguage = frontLanguage.value;
  saveStore();
  romanize();
});

watch(englishWord, (old) => {
  searchImageText.value = old ?? "";
});

onMounted(() => {
  gtag.event("page:add-card");
  //first login conversion
  gtag.event("conversion", {
    send_to: `AW-967082918/vwUvCJeBlJMDEKaHks0D`,
  });
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AddCardFront, {
      word: front.value,
      "front-language": frontLanguage.value,
      onInput: _cache[0] || (_cache[0] = (x) => (front.value = x)),
      onLanguageChange: _cache[1] || (_cache[1] = (l) => (frontLanguage.value = l))
    }, null, 8, ["word", "front-language"]),
    (romanization.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", null, _toDisplayString(romanization.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(AddCardLanguageDetection, {
      language: frontLanguage.value,
      text: front.value,
      onSetLanguage: _cache[2] || (_cache[2] = (lang) => (frontLanguage.value = lang))
    }, null, 8, ["language", "text"]),
    (front.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(canUseAudioFeature))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                (_unref(isLanguageAuto))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, " set language to create audio "))
                  : (!_unref(ttsSupported))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, " text to speech is not supported for this language "))
                    : _createCommentVNode("", true),
                (audioError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(audioError.value), 1))
                  : _createCommentVNode("", true),
                (creatingAudio.value)
                  ? (_openBlock(), _createBlock(Loading, {
                      key: 3,
                      class: "my-4"
                    }))
                  : (audioUrl.value)
                    ? (_openBlock(), _createElementBlock("audio", _hoisted_10, [
                        _createElementVNode("source", {
                          src: audioUrl.value,
                          type: "audio/mp3"
                        }, null, 8, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true),
                (_unref(ttsSupported) && audioUrl.value == '')
                  ? (_openBlock(), _createBlock(MyButton, {
                      key: 5,
                      onClickButton: onAddAudio,
                      disabled: _unref(isLanguageAuto)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_13,
          _createElementVNode("p", null, _toDisplayString(translationError.value), 1),
          (!english.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, " click the button to get translation "))
            : _createCommentVNode("", true),
          (!english.value)
            ? (_openBlock(), _createBlock(MyButton, {
                key: 2,
                onClickButton: _cache[3] || (_cache[3] = ($event: any) => (translateToEnglish())),
                class: "mb-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_font_awesome_icon, {
                      icon: "language",
                      size: "lg"
                    })
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(MyInput, {
                key: 3,
                value: english.value,
                onInputText: _cache[4] || (_cache[4] = (x) => (english.value = x))
              }, null, 8, ["value"])),
          _createVNode(LanguageDropdown, {
            class: "my-2 w-full",
            current: backLanguage.value,
            onSelected: _cache[5] || (_cache[5] = (x) => (backLanguage.value = x))
          }, null, 8, ["current"])
        ]))
      : _createCommentVNode("", true),
    (english.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          (selectedImage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(SquareImage, {
                  image: selectedImage.value,
                  size: 60,
                  class: "mt-4"
                }, null, 8, ["image"]),
                _createVNode(Attribution, {
                  image: selectedImage.value,
                  class: "mb-4"
                }, null, 8, ["image"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (!_unref(englishWord))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, " set language to english to use \"auto image search\" "))
                  : _createCommentVNode("", true),
                _createVNode(MyInput, {
                  class: "pt-3",
                  value: searchImageText.value,
                  onInputText: _cache[6] || (_cache[6] = (x) => (searchImageText.value = x))
                }, null, 8, ["value"]),
                (!images.value)
                  ? (_openBlock(), _createBlock(MyButton, {
                      key: 1,
                      class: "pt-3 my-3",
                      onClickButton: _cache[7] || (_cache[7] = ($event: any) => (searchImage()))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_font_awesome_icon, { icon: "image" })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (loadingImages.value)
                  ? (_openBlock(), _createBlock(Loading, {
                      key: 2,
                      class: "my-4"
                    }))
                  : _createCommentVNode("", true),
                (images.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(ImageSelectGrid, {
                        onSelected: _cache[8] || (_cache[8] = (image) => selectImage(image)),
                        images: images.value
                      }, null, 8, ["images"]),
                      _hoisted_26
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]))
      : _createCommentVNode("", true),
    (selectedImage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(MyButton, {
            onClickButton: _cache[9] || (_cache[9] = ($event: any) => (addCard()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_font_awesome_icon, { icon: "plus" })
              ])
            ]),
            _: 1
          }),
          _hoisted_30,
          _createVNode(MyButton, {
            onClickButton: _cache[10] || (_cache[10] = ($event: any) => (selectedImage.value = null))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_font_awesome_icon, { icon: "undo" })
              ])
            ]),
            _: 1
          })
        ]))
      : (english.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(MyButton, {
              onClickButton: _cache[11] || (_cache[11] = ($event: any) => (addCard()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_font_awesome_icon, { icon: "plus" })
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
    _hoisted_37
  ]))
}
}

})